import styled, { keyframes } from 'styled-components/macro'

import { colors } from 'styled/theme.styled'

const pulseRotate = keyframes`
0%, 70%, 100% {
  transform: rotate(90deg);
}
30%, 50% {
  transform: rotate(0);
}
`

export const Root = styled.div`
  position: absolute;
  inset: 0;
  background-color: ${colors.darkBlue};
  z-index: 999;

  display: ${({ show }) => (show ? 'flex' : 'none')};
  justify-content: center;
  align-items: center;

  > * {
    animation: ${pulseRotate} 2s infinite;
  }
`
